export default __webpack_public_path__ + "static/media/logo.6b8f6672.png";